// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import GroupPage from './pages/GroupPage';
import Pricing from './pages/Pricing';
import RespondPage from './pages/RespondPage';
import JoinGroup from './pages/JoinGroup';
import HowItWorks from './pages/HowItWorks';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import ParticipantList from './pages/ParticipantList';
import PaymentSuccess from './pages/PaymentSuccess';  // ✅ STRIPE
import PaymentCancel from './pages/PaymentCancel';    // ✅ STRIPE

function App() {
  return (
    <Router>
      <CookieBanner />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/groups/new" element={<GroupPage />} />
        <Route path="/groups/:groupId" element={<GroupPage />} />
        <Route path="/groups/:groupId/participants" element={<ParticipantList />} />
        <Route path="/priser" element={<Pricing />} />
        <Route path="/respond/:groupId/:participantId" element={<RespondPage />} />
        <Route path="/join/:groupId" element={<JoinGroup />} />
        
        {/* Info pages */}
        <Route path="/hur" element={<HowItWorks />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/kontakt" element={<Contact />} />
        
        {/* ✅ STRIPE: Payment pages */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        
        {/* Redirect old /admin to dashboard */}
        <Route path="/admin" element={<RedirectToDashboard />} />
      </Routes>
    </Router>
  );
}

// Helper component to redirect from old /admin to new dashboard
function RedirectToDashboard() {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/login" />;
  }
  
  return <Navigate to="/dashboard" />;
}

export default App;
